import React, { Component } from 'react';
import { observer , inject } from 'mobx-react';
import { Link } from "react-router-dom";
import { withRouter } from 'react-router-dom';
import DocumentTitle from 'react-document-title';
import TopNav from '../component/TopNav'; 
import CourseCard from '../component/CourseCard'; 
import Footer from '../component/Footer'; 
@withRouter
@inject("store")
@observer
export default class ProcessList extends Component
{
    state = { "courses":false };
    
    async componentDidMount()
    {
       const courses = await this.props.store.get_my_course_list('trying');
       if( courses )  this.setState({courses});
    }

    render()
    {
        const main = <div>
            <TopNav/>
            { !this.state.courses ? 
            <div className="container ft-notop">
                <div className="notice-box">没有学习中的完免课，<Link to="/course">点这里浏览课程</Link></div>
                
            </div>
            : 
                <div className="cate-course-list">
                <div className="container top50">
                    {this.state.courses.map( item =>  <CourseCard key={item.id} data={item} action="查看进度" url={"/process/"+item.id} /> )}
                </div></div>
            }
        <Footer/>
        </div>;
        return <DocumentTitle title={this.props.store.appname}>{main}</DocumentTitle>;
    }
}